import { render, staticRenderFns } from "./Wp_image.vue?vue&type=template&id=e19c9660&scoped=true&"
import script from "./Wp_image.vue?vue&type=script&lang=js&"
export * from "./Wp_image.vue?vue&type=script&lang=js&"
import style0 from "./Wp_image.vue?vue&type=style&index=0&id=e19c9660&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19c9660",
  null
  
)

export default component.exports